// Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export enum UnstakeDialogView {
    Unstake = 'unstake',
    TimelockedUnstake = 'timelockedUnstake',
    TransactionDetails = 'transactionDetails',
}
